<template>
  <div class="erp-approved-consums-page">
    <card :title="$t('tools.erp_integration.approved_consums_title')" id="erp-approved-consums">
      <div class="page-actions">
        <router-link to="/tools/erp-integration/consum" class="btn btn-md btn-secondary">
          {{ $t("common.back_to_list") }}
        </router-link>
        <button type="button" class="btn btn-md btn-outline-primary" @click="reloadApprovedConsums">
          {{ $t("common.refresh") }}
        </button>
      </div>

      <ApprovedConsumsGrid ref="approvedConsumsGrid" @open-audit="openBatchAudit" />
    </card>
  </div>
</template>

<script>
import ApprovedConsumsGrid from "@/pages/tools/erp-integration/consum/components/ApprovedConsumsGrid.vue";

export default {
  name: "ErpApprovedConsumsPage",
  components: {
    ApprovedConsumsGrid,
  },
  methods: {
    openBatchAudit({ uuid }) {
      this.$router.push({ path: "/tools/erp-integration/consum", query: { queue_uuid: uuid } });
    },
    reloadApprovedConsums() {
      this.$refs.approvedConsumsGrid?.reload();
    },
  },
};
</script>

<style scoped>
.page-actions {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
}
</style>
